<section class="gallery-wrapper">
  <div *ngIf="items && items.length > 0" class="top-info is-flex has-flex-align-center has-flex-content-space-between">
    <span class="has-pos-rel listings-count hide-on-mobile" translate="gallery.items-of-total-count" [translateParams]="{total: pagination.totalResults, items: pagination.currentNumberShown}"></span>
    <span class="has-pos-rel listings-count hide-on-tablet-up" style="margin-bottom: 10px;" translate="gallery.items-count" [translateParams]="{total: pagination.totalResults}"></span>
    <form [formGroup]="sortForm" [class.hidden]="shouldHideSorting">
      <app-select [options]="sortOptions" [formControl]="sortForm.controls['sort']" [parentFormGroup]="sortForm"></app-select>
    </form>
  </div>
  <div class="gallery-container full-width is-flex has-flex-wrap has-flex-content-center"
    [class.has-flex-align-center]="items && items.length === 0"
    infiniteScroll
    [infiniteScrollDistance]="2"
    [infiniteScrollThrottle]="500"
    [scrollWindow]="true"
    (scrolled)="onGalleryScrolled()">
    <div class="gallery-list full-width is-flex has-flex-wrap has-flex-content-center has-flex-align-start" [class.empty]="!items || items.length === 0">
      <ng-container *ngIf="!isFetchingItems && (!items || items.length === 0)">
        <h4 class="full-width text-center" translate="panel-message.no-results"></h4>
      </ng-container>
      <ng-content></ng-content>
    </div>
    <app-pagination class="hide-on-mobile" [totalPages]="pagination.totalPages" [currentPageNumber]="pagination.pageNumber" (onChangePage)="changePage.emit($event)"
    ></app-pagination>
  </div>

  <app-loader [isLoading]="isFetchingItems"></app-loader>
</section>
